import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { SeoRouterListenerService } from './app/service/seo-router-listener.service';

bootstrapApplication(AppComponent, appConfig)
  .then(appRef => {
    // ✅ SEO dinamico basato su data.seo delle routes
    const seoListener = appRef.injector.get(SeoRouterListenerService);
    seoListener.init();
  })
  .catch((err) => console.error(err));
